// Single import point: `import MathEquation from '../plugins/mathequation/mathequation'`.
// The "Math/Chem Equation" toolbar UI itself lives in TemplatePanel.js --
// this plugin only provides the schema/converters/command that make the
// equation widget exist in the document at all.
export { default } from './mathequationediting';
